import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import Header from './Components/Navbar/Header';
import Footer from './Components/Navbar/Footer';
import ShanmugaChatbot from './Components/Shared/Shanmugachatbot';
import ScrollToTop from './Components/Shared/ScrollToTop';
import LoadingSpinner from './Components/Shared/LoadingSpinner';

// Lazy-loaded Pages for Route Code Splitting
const About = lazy(() => import('./Pages/About/About'));
const Objectives = lazy(() => import('./Pages/About/Objectives'));
const VisionMission = lazy(() => import('./Pages/About/VisionAndMission'));
const Faculty = lazy(() => import('./Pages/Academics/Faculty'));
const Library = lazy(() => import('./Pages/Facilities/Library'));
const Classroom = lazy(() => import('./Pages/Facilities/Classroom'));
const Laboratory = lazy(() => import('./Pages/Facilities/Laboratory'));
const ClinicalExperience = lazy(() => import('./Pages/Academics/ClinicalExperience'));
const Hostel = lazy(() => import('./Pages/Facilities/Hostel'));
const EventsCompleted = lazy(() => import('./Pages/Events/Eventcompleted'));
const PrincipalsMessage = lazy(() => import('./Pages/About/PrincipalsMessage'));
const CampusInfo = lazy(() => import('./Pages/Facilities/CampusInfo'));
const Activities = lazy(() => import('./Pages/Events/Activities'));
const Courses = lazy(() => import('./Pages/Academics/Courses'));
const UpcomingEvents = lazy(() => import('./Pages/Events/UpcomingEvents'));
const Alumni = lazy(() => import('./Pages/Alumni/Alumni'));
const SportsAndRecreation = lazy(() => import('./Pages/Facilities/SportsAndRecreation'));
const AlumniRegistration = lazy(() => import('./Pages/Alumni/AlumniRegistration'));
const PlacementDetails = lazy(() => import('./Pages/Alumni/PlacementDetails'));
const EnquiryAndCourses = lazy(() => import('./Pages/About/EnquiryAndCourses'));
const Messages = lazy(() => import('./Pages/About/Messages'));
const TieUp = lazy(() => import('./Pages/Academics/TieUp'));
const ResearchShowcase = lazy(() => import('./Pages/Academics/Reaserch'));
const GraduationAnnouncement = lazy(() => import('./Pages/Events/Graduation'));
const TriFestProgram = lazy(() => import('./Pages/Events/OtherEvents'));

const AboutSMRFT = lazy(() => import('./Pages/Smrft/About'));
const ObjectivesSMRFT = lazy(() => import('./Pages/Smrft/Objectives'));
const ActivitiesSMRFT = lazy(() => import('./Pages/Smrft/Activities'));
const ServicesSMRFT = lazy(() => import('./Pages/Smrft/Services'));
const FCRA = lazy(() => import('./Pages/Smrft/FCRA'));
const Contribution = lazy(() => import('./Pages/Smrft/Contribution'));

const AdminDashboard = lazy(() => import('./Pages/Admin/AdminDashboard'));
const AdminLogin = lazy(() => import('./Pages/Admin/AdminLogin'));

// Group Lazy Imports
const GroupLanding = lazy(() => import('./Pages/Group/GroupLanding'));
const AboutGroup = lazy(() => import('./Pages/Group/AboutGroup'));
const ProgrammesGroup = lazy(() => import('./Pages/Group/ProgrammesGroup'));
const FacilitiesGroup = lazy(() => import('./Pages/Group/FacilitiesGroup'));
const ClinicalGroup = lazy(() => import('./Pages/Group/ClinicalGroup'));
const FacultyGroup = lazy(() => import('./Pages/Group/FacultyGroup'));
const HostelGroup = lazy(() => import('./Pages/Group/HostelGroup'));
const ResearchGroup = lazy(() => import('./Pages/Group/ResearchGroup'));
const StudentWelfareGroup = lazy(() => import('./Pages/Group/StudentWelfareGroup'));
const AlumniGroup = lazy(() => import('./Pages/Group/AlumniGroup'));

function App() {
  const location = useLocation();
  const isHome = location.pathname === '/ShanmugaNursingCollege/' || location.pathname === '/ShanmugaNursingCollege';

  useEffect(() => {
    document.body.className = isHome ? 'home' : 'default';
    return () => {
      document.body.className = '';
    };
  }, [isHome]);

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <ShanmugaChatbot />
      <main>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Shanmuga Nursing College Routes */}
            <Route path="/ShanmugaNursingCollege/" element={<div className="home-splash" />} />
            <Route path="/ShanmugaNursingCollege/About" element={<About />} />
            <Route path="/ShanmugaNursingCollege/Objectives" element={<Objectives />} />
            <Route path="/ShanmugaNursingCollege/VisionMission" element={<VisionMission />} />
            <Route path="/ShanmugaNursingCollege/Faculty" element={<Faculty />} />
            <Route path="/ShanmugaNursingCollege/Library" element={<Library />} />
            <Route path="/ShanmugaNursingCollege/Classroom" element={<Classroom />} />
            <Route path="/ShanmugaNursingCollege/Laboratory" element={<Laboratory />} />
            <Route path="/ShanmugaNursingCollege/Courses" element={<Courses />} />
            <Route path="/ShanmugaNursingCollege/ClinicalExperience" element={<ClinicalExperience />} />
            <Route path="/ShanmugaNursingCollege/SportsAndRecreation" element={<SportsAndRecreation />} />
            <Route path="/ShanmugaNursingCollege/Hostel" element={<Hostel />} />
            <Route path="/ShanmugaNursingCollege/PrincipalsMessage" element={<PrincipalsMessage />} />
            <Route path="/ShanmugaNursingCollege/CampusInfo" element={<CampusInfo />} />
            <Route path="/ShanmugaNursingCollege/Activities" element={<Activities />} />
            <Route path="/ShanmugaNursingCollege/EventsCompleted" element={<EventsCompleted />} />
            <Route path="/ShanmugaNursingCollege/UpcomingEvents" element={<UpcomingEvents />} />
            <Route path="/ShanmugaNursingCollege/Alumni" element={<Alumni />} />
            <Route path="/ShanmugaNursingCollege/AlumniRegistration" element={<AlumniRegistration />} />
            <Route path="/ShanmugaNursingCollege/PlacementDetails" element={<PlacementDetails />} />
            <Route path="/ShanmugaNursingCollege/EnquiryAndCourses" element={<EnquiryAndCourses />} />
            <Route path="/ShanmugaNursingCollege/Messages" element={<Messages />} />
            <Route path="/ShanmugaNursingCollege/TieUp" element={<TieUp />} />
            <Route path="/ShanmugaNursingCollege/ResearchShowcase" element={<ResearchShowcase />} />
            <Route path="/ShanmugaNursingCollege/Graduation" element={<GraduationAnnouncement />} />
            <Route path="/ShanmugaNursingCollege/ShanmugaChatbot" element={<ShanmugaChatbot />} />
            <Route path="/ShanmugaNursingCollege/Others" element={<TriFestProgram />} />

            <Route path="/AdminDashboard" element={<AdminDashboard />} />
            <Route path="/Admin" element={<AdminLogin />} />

            {/* Global Landing Page */}
            <Route path="/" element={<GroupLanding />} />

            {/* Group Routes */}
            <Route path="/Group/About" element={<AboutGroup />} />
            <Route path="/Group/Programmes" element={<ProgrammesGroup />} />
            <Route path="/Group/Facilities" element={<FacilitiesGroup />} />
            <Route path="/Group/Clinical" element={<ClinicalGroup />} />
            <Route path="/Group/Faculty" element={<FacultyGroup />} />
            <Route path="/Group/Hostel" element={<HostelGroup />} />
            <Route path="/Group/Research" element={<ResearchGroup />} />
            <Route path="/Group/StudentWelfare" element={<StudentWelfareGroup />} />
            <Route path="/Group/Alumni" element={<AlumniGroup />} />

            {/* SMRFT Routes */}
            <Route path="/Smrft/About" element={<AboutSMRFT />} />
            <Route path="/Smrft/Objectives" element={<ObjectivesSMRFT />} />
            <Route path="/Smrft/Activities" element={<ActivitiesSMRFT />} />
            <Route path="/Smrft/Services" element={<ServicesSMRFT />} />
            <Route path="/Smrft/FCRA" element={<FCRA />} />
            <Route path="/Smrft/Contribution" element={<Contribution />} />
          </Routes>
        </Suspense>
      </main>
      {!isHome && <Footer />}
    </div>
  );
}

export default App;
